import React from 'react'

export default function InformacionFamiliar() {
  return (
    <div>
      InformacionFamiliar
    </div>
  )
}
